(() => {
  const root = document.querySelector('[data-bnf-editorial]');
  if (!root) return;
  const incoming = new URLSearchParams(window.location.search);
  const allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  root.querySelectorAll('[data-ed-cta]').forEach((link) => {
    const destination = new URL(link.getAttribute('href'), window.location.origin);
    if (destination.origin !== window.location.origin || !destination.pathname.startsWith('/products/')) return;
    allowed.forEach((key) => {
      const value = incoming.get(key);
      if (value && value.length <= 200) destination.searchParams.set(key, value);
    });
    link.href = destination.pathname + destination.search;
  });
})();
